import axios from 'axios';

// AuthContextのlogoutをimportするため、後でexportする
let logoutHandler = null;
export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

// Axiosインスタンス作成
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// 401エラー時に自動ログアウト
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      if (logoutHandler) {
        logoutHandler();
      }
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  }
);

// API関数
export const postLogin = (username, password) =>
  api.post('/token/', { username, password });

export const getSoftwareCategories = (accessToken) =>
  api.get('/software/categories/', {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });

export default api; 